import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["frame", "trigger"];
  static values = {
    details: Object,
  };

  connect() {
    this._json = this.detailsValue;
  }

  openModal() {
    const html = this.renderModal(this._json);
    this.frameTarget.innerHTML = html;


    this.frameTarget.classList.remove('hidden');
    setTimeout(() => {
      this.frameTarget.classList.remove('top-[-100%]');
      this.frameTarget.classList.add('top-0');
    }, 10);
  }

  closeModal() {
    this.frameTarget.classList.add('top-[-100%]');
    setTimeout(() => {
      this.frameTarget.innerHTML = '';
      this.frameTarget.classList.add('hidden');
    }, 1000);
  }

  renderModal(projectDetails) {
    return `
      <div class="p-5 bg-white shadow-md rounded-md w-full max-w-4xl mx-auto relative mt-5">
        <!-- Title of the Modal -->
        <h2 class="text-2xl font-bold text-center mb-6">Detalii Apel</h2>

        <!-- Project Details -->
        <div class="mb-6 font-normal">
          <h3 class="font-semibold text-lg">${projectDetails.title}</h3>
          <div class="py-4 border-b border-color-light-04"><strong>Domeniu:</strong> ${projectDetails.domain}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Obiectiv Specific:</strong> ${projectDetails.specific_objective}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Obiectiv General:</strong> ${projectDetails.general_objective}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Suma Totală:</strong> ${projectDetails.total_amount}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Suma Cofinanțare UE:</strong> ${projectDetails.cofinance_ue_amount}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Beneficiar:</strong> ${projectDetails.recipient}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Data Începerii:</strong> ${projectDetails.start_date}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Data Finalizării:</strong> ${projectDetails.end_date}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Tipul Apelului:</strong> ${projectDetails.call_type}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Data Publicării Ghidului Inițial:</strong> ${projectDetails.initial_guide_publication_date}</div>
          <div class="py-4 border-b border-color-light-04"><strong>Data Publicării Ghidului Final:</strong> ${projectDetails.guide_publication_date}</div
        </div>

        <!-- Close Button -->
        <div class="text-center mt-6 absolute top-0 right-5">
          <button data-action="click->calls-modal#closeModal">
            <i class="icon-circle-x text-2xl text-color-light"></i>
          </button>
        </div>
      </div>
    `;
  }

  openOnClick(event) {
    event.preventDefault();
    this.openModal();
  }
}
